import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/reservation`;

export default {
  async list(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/list`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async overlapped(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/overlapped`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async create(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/create?lang=${params.lang}`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async get(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/getDetail`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async edit(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/edit?lang=${params.lang}`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async delete(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      await axios.post(`${apiUrl}/${apiPath}/delete?lang=${params.lang}`, params);
      return {
        // data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
